module.exports = __webpack_public_path__ + "img/search-hero-overflow-mazda.a94dd9e7.png";